import React from 'react'
import { NativeLazyLoading, StyledImage } from './Image.web.styled'

export interface ImageProps {
    src: string
    srcSet?: string
    sizes?: string
    alt?: string
    enableFadeIn: boolean
    className?: string
    loading?: NativeLazyLoading
    onError?: () => void
    height?: string
    width?: string
}

export const Image = React.forwardRef<HTMLImageElement, ImageProps>(
    (
        {
            enableFadeIn,
            src,
            srcSet,
            sizes,
            alt,
            className,
            loading,
            onError,
            height,
            width,
        },
        ref,
    ) => {
        const [loaded, setLoaded] = React.useState(enableFadeIn === false)
        function onLoad() {
            setLoaded(true)
        }

        return (
            <StyledImage
                ref={ref}
                show={loaded}
                onLoad={onLoad}
                onError={onError}
                src={src}
                srcSet={srcSet}
                sizes={sizes}
                alt={alt}
                className={className}
                loading={loading}
                height={height}
                width={width}
            />
        )
    },
)

Image.displayName = 'Image'
